var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-icon",class:`icon-${_vm.size}`},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","role":"img","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.icons[_vm.name]}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }